import React from 'react'
import { useTranslation } from 'react-i18next'

export interface CommonWebsiteLayoutBodyProps {
  header: React.ReactNode
  content?: React.ReactNode
  footer: React.ReactNode
}

export const CommonWebsiteLayoutBody = ({
  header,
  content,
  footer,
}: CommonWebsiteLayoutBodyProps) => {
  const { t } = useTranslation()

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {header}
      <main>
        {content ?? (
          <div
            style={{
              minHeight: '640px',
              width: '100%',
              backgroundColor: 'fff',
            }}
          >
            {t('components.website_layout_body.content_placeholder')}
          </div>
        )}
      </main>
      {footer}
    </div>
  )
}
